import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar } from "./progressbar";

const loadVr = () => {
    const promiseVr = new Promise((resolve, reject) => {
        loader.load(
            "office/model/vr/vr.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                // Posizione iniziale da regolare
                model.position.set(1.569492122817048, 2.1348491504677787, 4);
                model.scale.set(0.2, 0.2, 0.2);
                model.rotation.set(0, -1.0424849729027907, 0);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                // Abilitiamo il ControlFunction per posizionarlo con il mouse
              //  ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseVr;
};

export { loadVr };
